<template>
  <AGAutocomplete
    :id="id"
    v-model="localValue"
    label="Etapa de análise"
    item-title="text"
    item-value="value"
    :items="items"
    :hint="hint"
    :disabled="disabled"
    :multiple="multiple"
    :has-select-all="hasSelectAll"
    :rules="rules"
    :message-color="messageColor"
    :menu-height="400"
  />
</template>

<script>
import AGAutocomplete from '@/components/common/AGAutocomplete.vue';
import ETAPA_ANALISE from '@/constants/ConstantEtapaAnalise';
import { MESSAGE_COLOR } from '@/constants/ConstantMessageColor';
import { uniqueId } from 'lodash';

export default {
  components: { AGAutocomplete },

  emits: ['update:modelValue'],

  props: {
    modelValue: {
      type: [Boolean, String, Number, Array, Object, null],
      required: true,
    },
    id: {
      type: String,
      default: uniqueId('agAutocompleteEtapaAnalise'),
    },
    hint: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hasSelectAll: {
      type: Boolean,
      default: false,
    },
    messageColor: {
      type: String,
      default: MESSAGE_COLOR.DEFAULT,
      validator: (val) => Object.values(MESSAGE_COLOR).includes(val),
    },
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    items() {
      return Object.keys(ETAPA_ANALISE).map((etapa) => ({
        text: this.getLabel(etapa),
        value: etapa,
      }));
    },
  },
  methods: {
    getLabel(etapa) {
      switch (etapa) {
        case ETAPA_ANALISE.ANALISAR:
          return 'Analisar';
        case ETAPA_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
          return 'Esclarecimento';
        case ETAPA_ANALISE.EM_ANALISE:
          return 'Em análise';
        case ETAPA_ANALISE.APTO_PARA_REVISAO:
          return 'Apto para revisão';
        case ETAPA_ANALISE.REVISADO:
          return 'Revisado';
        case ETAPA_ANALISE.ANALISADO:
          return 'Analisado';
        default:
          console.error(`Etapa de análise "${etapa}" não está mapeado`);
          return etapa;
      }
    },
  },
};
</script>
